<template>
    <nav
        class="navbar fixed-top navbar-light top-nvb"
        :class="route"
    >
        <router-link 
            tag="span" 
            :to="{ name: 'BookMarks' }" 
            class="navbar-brand"
        >
            <img :src="SandoghcheGanj" width="30" height="30" alt="">
        </router-link>

        <div class="form-group">
            <input 
                v-model="search" type="text" 
                id="searchFeild" class="form-control"
                placeholder="جستجو در رسانه"
                v-bind:style="{ 'background-image': 'url(' + Search + ')' }"
            >
        </div>

        <div class="nav-container">
            <router-link 
                class="resaneh-link" 
                :class="{ 'active': route == 'Video'}" 
                :to="{ name: 'Video'}"
            >
                <template v-if="route == 'Video'">
                    <img :src="cVideo" alt="Video">
                    <span>ویدیو</span>
                </template>
                <template v-else>
                    <img :src="Video" alt="Video">
                    <span>ویدیو</span>
                </template>
            </router-link>
            <router-link 
                class="resaneh-link" 
                :class="{ 'active': route == 'Podcast'}" 
                :to="{ name: 'Podcast'}"
            >
                <template v-if="route == 'Podcast'">
                    <img :src="cPodcast" alt="Podcast">
                    <span>پادکست</span>
                </template>
                <template v-else>
                    <img :src="Podcast" alt="Podcast">
                    <span>پادکست</span>
                </template>
            </router-link>
            <router-link 
                class="resaneh-link" 
                :class="{ 'active': route == 'Webinar'}" 
                :to="{ name: 'Webinar'}"
            >
                <template v-if="route == 'Webinar'">
                    <img :src="cWebinar" alt="Webinar">
                    <span>وبینار</span>
                </template>
                <template v-else>
                    <img :src="Webinar" alt="Webinar">
                    <span>وبینار</span>
                </template>
            </router-link>
        </div>
    </nav>
</template>

<script>
import Search from '@/assets/images/resaneh/search.png';
import SandoghcheGanj from '@/assets/images/resaneh/sandoghche_ganj.png';

import Webinar from '@/assets/images/resaneh/webinar.png';
import cWebinar from '@/assets/images/resaneh/cwebinar.png';
import Video from '@/assets/images/resaneh/video.png';
import cVideo from '@/assets/images/resaneh/cvideo.png';
import Podcast from '@/assets/images/resaneh/podcast.png';
import cPodcast from '@/assets/images/resaneh/cpodcast.png';

export default {
    name: 'ResanehHeader',
    data() {
        return {
            Search: Search,
            SandoghcheGanj: SandoghcheGanj,

            Webinar: Webinar,
            cWebinar: cWebinar,
            Video: Video,
            cVideo: cVideo,
            Podcast: Podcast,
            cPodcast: cPodcast,

            search: undefined,
            route: this.$route.name,
        }
    },
    watch: {
        '$route'() {
            this.route = this.$route.name;
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* --------------- GENERAL ---------------- */
/* ---------------------------------------- */
.fa-size {
    font-size: 2rem;
}
.top-nvb {
    min-height: 80pt;

    display: flex;
    flex-direction: row;

    padding: 0 !important;
    padding-top: 10pt !important;
}
.top-nvb .form-group {
    width: calc(100% - 45pt);

    margin: auto;
    margin-left: -1pt;
}
.top-nvb .form-group input {
    height: 35pt;
    padding-right: 50px;
    
    border-top-right-radius: 20pt;
    border-bottom-right-radius: 20pt;

    direction: rtl;

    background-size: 15px 15px;
    background-repeat: no-repeat;
    background-position: calc(100% - 20px) 10pt;
}
.top-nvb .navbar-brand {
    margin-right: auto;
    margin-left: 0;

    cursor: pointer;
}
.top-nvb .nav-container {
    height: 35pt;
    width: 100%;
}
.top-nvb .nav-container .resaneh-link {
    width: 33.33%;
    height: calc(100% - 10pt);
    margin-top: 10pt;
  
    text-align: center;
    font-weight: bold;
    display: inline-block;
    text-decoration: none !important;

    display: inline-block;
    padding: 0 !important;
}
.top-nvb .nav-container .resaneh-link img {
    height: 1rem;
    margin: auto auto auto 3pt;
}
.top-nvb .nav-container .resaneh-link span {
    margin: auto 3pt auto auto;
    display: inline-block;
}

/* ---------------------------------------- */
/* ------------ SPECIFIC COLORS ----------- */
/* ---------------------------------------- */
.BookMarks {
    background-color: #666;
    box-shadow: 2px 1px 6px #ddd;
}
.BookMarks .form-group input {
    color: #444d;
    border-color: #ddd;
    background-color: #aaa;
    box-shadow: inset 3px 3px 6px 0px #555555ab;
}
.BookMarks .form-group input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #ddd;
}
.BookMarks .form-group input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color: #ddd;
   opacity:  1;
}
.BookMarks .form-group input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color: #ddd;
   opacity:  1;
}
.BookMarks .form-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #ddd;
}
.BookMarks .form-group input::-ms-input-placeholder { /* Microsoft Edge */
   color: #ddd;
}
.BookMarks .form-group input::placeholder { /* Most modern browsers support this now. */
   color: #ddd;
}
.BookMarks .nav-container .resaneh-link {
    color: #ddd;
    border-bottom: 3px solid #aaa;
}
.BookMarks .nav-container .resaneh-link.active {
    color: #ddd;
    border-bottom: 3px solid #aaa
}
.BookMarks .nav-container .resaneh-link:active,
.BookMarks .nav-container .resaneh-link:hover {
    border-bottom: 3px solid #eee
}
/* podcast */
.Podcast {
    background-color: #665100;
    box-shadow: 2px 1px 6px #4d3d00;
}
.Podcast .form-group input {
    color: #806f27dd;
    border-color: #4d3d00;
    background-color: #665100;
    box-shadow: inset 3px 3px 6px 0px #4d3d00ab;
}
.Podcast .form-group input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #806f27dd;
}
.Podcast .form-group input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color: #806f27dd;
   opacity:  1;
}
.Podcast .form-group input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color: #806f27dd;
   opacity:  1;
}
.Podcast .form-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #806f27dd;
}
.Podcast .form-group input::-ms-input-placeholder { /* Microsoft Edge */
   color: #806f27dd;
}
.Podcast .form-group input::placeholder { /* Most modern browsers support this now. */
   color: #806f27dd;
}
.Podcast .nav-container .resaneh-link {
    color: #806f27dd;
    border-bottom: 3px solid #665100;
}
.Podcast .nav-container .resaneh-link.active {
    color: #fece02dd;
    border-bottom: 2px solid #fece02
}
.Podcast .nav-container .resaneh-link:active,
.Podcast .nav-container .resaneh-link:hover {
    border-bottom: 2px solid #fece02
}
/* webinar */
.Webinar {
    background-color: #095834;
    box-shadow: 2px 1px 6px #063720;
}
.Webinar .form-group input {
    color: #377358dd;
    border-color: #063720;
    background-color: #095834;
    box-shadow: inset 3px 3px 6px 0px #063720ab;
}
.Webinar .form-group input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #377358dd;
}
.Webinar .form-group input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color: #377358dd;
   opacity:  1;
}
.Webinar .form-group input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color: #377358dd;
   opacity:  1;
}
.Webinar .form-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #377358dd;
}
.Webinar .form-group input::-ms-input-placeholder { /* Microsoft Edge */
   color: #377358dd;
}
.Webinar .form-group input::placeholder { /* Most modern browsers support this now. */
   color: #377358dd;
}
.Webinar .nav-container .resaneh-link {
    color: #377358dd;
    border-bottom: 3px solid #095834;
}
.Webinar .nav-container .resaneh-link.active {
    color: #46ff7edd;
    border-bottom: 2px solid #46ff7e
}
.Webinar .nav-container .resaneh-link:active,
.Webinar .nav-container .resaneh-link:hover {
    border-bottom: 2px solid #46ff7e
}
/* video */
.Video {
    background-color: #004152;
    box-shadow: 2px 1px 6px #003644;
}
.Video .form-group input {
    color: #316270dd;
    border-color: #003644;
    background-color: #004152;
    box-shadow: inset 3px 3px 6px 0px #003644ab;
}
.Video .form-group input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #316270dd;
}
.Video .form-group input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color: #316270dd;
   opacity:  1;
}
.Video .form-group input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color: #316270dd;
   opacity:  1;
}
.Video .form-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #316270dd;
}
.Video .form-group input::-ms-input-placeholder { /* Microsoft Edge */
   color: #316270dd;
}
.Video .form-group input::placeholder { /* Most modern browsers support this now. */
   color: #316270dd;
}
.Video .nav-container .resaneh-link {
    color: #316270dd;
    border-bottom: 3px solid #004152;
}
.Video .nav-container .resaneh-link.active {
    color: #00c9ffdd;
    border-bottom: 2px solid #00c9ff
}
.Video .nav-container .resaneh-link:active,
.Video .nav-container .resaneh-link:hover {
    border-bottom: 2px solid #00c9ff
}

/* ---------------------------------------- */
/* -------------- RESPONSIVE  ------------- */
/* ---------------------------------------- */
@media (max-width: 576px) {
    .top-nvb .nav-container .resaneh-link span {
        font-size: 0.8rem;
        margin: auto 2pt auto auto;
    }
    .top-nvb .nav-container .resaneh-link img {
        height: 0.8rem;
        margin: auto auto auto 2pt;
    }
}
</style>

